export default {"src":"/_next/static/media/report.97110ebd.svg","height":57,"width":67};